import type { MappedFiltersType } from './mapFilters';
import {
  filterByDate,
  filterByHashtag,
  filterByKeyword,
  filterByURL,
  filterByValueEqual
} from './variants';

interface OptionsType {
  message: string;
  postUrl: string;
  creationTimestamp: number;
  username: string;
}

export const applyFilters = (
  filters: Partial<MappedFiltersType> | null,
  options: OptionsType
) => {
  if (!filters) {
    return true;
  }

  let shouldShowPost: boolean | undefined;
  const filtersKeys = Object.keys(filters);

  let hadIncludeFilter = false;

  filtersKeys.forEach((filterKey) => {
    const haveIncludeFilters = !!filters[filterKey]!.include.length;
    hadIncludeFilter ||= haveIncludeFilters;

    const isFilterEmpty =
      !hadIncludeFilter && !filters[filterKey]!.exclude.length;

    if (shouldShowPost === false || isFilterEmpty) {
      return;
    }

    let filterResult;

    switch (filterKey) {
      case 'hashtag':
        filterResult = filterByHashtag(options.message, filters[filterKey]!);
        break;
      case 'keyword':
        filterResult = filterByKeyword(options.message, filters[filterKey]!);
        break;
      case 'specificPost':
        filterResult = filterByURL(options.postUrl, filters[filterKey]!);
        break;
      case 'specificUser':
        filterResult = filterByValueEqual(
          options.username,
          filters[filterKey]!
        );
        break;
      case 'date':
        filterResult = filterByDate(
          options.creationTimestamp,
          filters[filterKey]!
        );
        break;
      default:
        break;
    }

    if (filterResult?.shouldExclude) {
      shouldShowPost = false;
    } else if (filterResult?.shouldInclude) {
      shouldShowPost = true;
    }
  });

  if (!hadIncludeFilter && shouldShowPost === undefined) {
    return true;
  }

  return !!shouldShowPost;
};
